import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyB3iZQo_fJdH2cGzdCYN50--xTPWgXBRgk",
    authDomain: "schedulum-7d3b0.firebaseapp.com",
    projectId: "schedulum-7d3b0",
    storageBucket: "schedulum-7d3b0.firebasestorage.app",
    messagingSenderId: "999831171054",
    appId: "1:999831171054:web:3da52f04f4861133e4e8ff",
    measurementId: "G-FEPCD72Q7N"
};

export const firebaseApp = initializeApp(firebaseConfig);
